import { createContext, useContext, useState, useCallback } from "react";

export const LANGUAGES = [
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
  { code: "ru", label: "Русский", flag: "🇷🇺" },
  { code: "bg", label: "Български", flag: "🇧🇬" },
  { code: "pt", label: "Português", flag: "🇵🇹" },
];

const LanguageContext = createContext({ lang: "es", setLang: () => {} });

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("site_lang") || "es");
  const setLang = useCallback((code) => {
    localStorage.setItem("site_lang", code);
    setLangState(code);
  }, []);
  return (
    <LanguageContext.Provider value={{ lang, setLang }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
